import FormControl from '@mui/material/FormControl';
import InputLabel from "@mui/material/InputLabel/InputLabel";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { OutlinedInput, SelectChangeEvent } from '@mui/material';
import { useState, useEffect } from 'react';
import FormHelperText from '@mui/material/FormHelperText';

export type Props = {
    name: string,
    label: string,
    options: string[],
    value?: string,
    error?: boolean, 
    required?: boolean, 
    readOnly?: boolean,
    errorText?: string,
    disabled?: boolean,
    onChange?: (event: SelectChangeEvent<string>) => void,
    format?: string,
};

export const Picker = (dataDropDownProps: Props) => {
    const { name, label, options, value, error, readOnly, required, errorText, onChange, disabled = false, format } = dataDropDownProps;
    const [newValue, setNewValue] = useState('');
    const [isError, setIsError] = useState(error);
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        setRequiredError(error);
    }, [error]);

    const selectChange = (event: SelectChangeEvent<string>) => {
        setNewValue(event.target.value);
    };

    const setRequiredError = (error: boolean | undefined) => {
        setIsError(error);
        (error) ? <> {setErrorMsg('Field is required')}</> : setErrorMsg('');
    }

    const onHandleBlur = (event : {}) => {
        const e = event as React.FocusEvent<HTMLInputElement>;        
        ((value == "" || !value) && (required)) ? setRequiredError(true) : setRequiredError(false);
    }

    return (
        <FormControl sx={{ m: 0 }} fullWidth required={required} error={error} variant={readOnly ? "standard" : "outlined"} >
            <InputLabel htmlFor={name}>{label}</InputLabel>
            <Select
                id={name}
                name={name}
                label={name}
                value={newValue || value || ''}
                // input={<OutlinedInput label={name}/>}
                onChange={((onChange !== undefined) ? onChange : selectChange)}
                sx={{ textAlign: 'left' }}
                variant={readOnly ? "standard" : "outlined"}
                onBlur={onHandleBlur}
                required={required}
                disabled={disabled}
            >
                {
                    options.map((item: string, index: number) => {
                        let str = item.split(/(?=[A-Z])/);
                        str[0] = str[0][0].toUpperCase() + str[0].slice(1);

                        return (
                            <MenuItem key={index} value={item}>{(format==='camelCase') ? str.join(" ") : item}</MenuItem>

                        );
                    })
                }
            </Select>
            <FormHelperText style={{color:'red'}}>{isError ? errorMsg : ''}</FormHelperText>
        </FormControl>
    );
};

export default Picker;